var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8974 12.8055L10.5872 9.50171C10.5051 9.4471 10.4231 9.39249 10.341 9.39249H9.98534C10.8334 8.40956 11.3806 7.09898 11.3806 5.67918C11.3806 2.56655 8.80899 0 5.69028 0C2.54421 0 0 2.56655 0 5.67918C0 8.81911 2.54421 11.3584 5.69028 11.3584C7.11285 11.3584 8.39863 10.8396 9.41084 9.99317V10.3481C9.41084 10.43 9.4382 10.5119 9.49292 10.5939L12.8031 13.8976C12.9399 14.0341 13.1588 14.0341 13.2682 13.8976L13.8974 13.2696C14.0342 13.1604 14.0342 12.942 13.8974 12.8055ZM5.69028 10.0478C3.2555 10.0478 1.31314 8.10921 1.31314 5.67918C1.31314 3.27645 3.2555 1.31058 5.69028 1.31058C8.0977 1.31058 10.0674 3.27645 10.0674 5.67918C10.0674 8.10921 8.0977 10.0478 5.69028 10.0478Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.23cd081113237d057bc3472905df8a01.svg";
export { ForwardRef as ReactComponent };